import styled from 'styled-components'

import MediaList from '../MediaList'
import SectionWrapper from '../SectionWrapper'
import ActionButton from '../ActionButton'

export const Container = styled(SectionWrapper)`
  padding: 5.2rem 0;
  text-align: center;
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.firaSans3XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-bottom: 5rem;
  text-align: left;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    ${({ theme }) => theme.textStyles.firaSans2XlBold};
    font-weight: bold;
    margin-bottom: 2rem;
  }
`

export const SeeMore = styled(ActionButton)`
  margin-top: 5rem;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    margin-top: 4rem;
  }
`

export const Medias = styled(MediaList)``
